import { render, staticRenderFns } from "./MerchantPOS.vue?vue&type=template&id=4f9a85e1&"
import script from "./MerchantPOS.vue?vue&type=script&lang=js&"
export * from "./MerchantPOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports